<div class="bar-graph-table-row text">
    <div class="col-no column">
        {{ rowIndex + 1 }}
    </div>
    <div class="col-channel column">
        <ng-container *ngIf="!channel.channel">
            <div class="select-button" (click)="openChannelSelector()">
                {{ 'graph.bar.table.channel.button.select' | translate }}
            </div>
        </ng-container>
        <ng-container *ngTemplateOutlet="channelRow; context: { channel: channel.channel }"></ng-container>
    </div>
    <div class="col-bar-label column" [class.not-selected]="!channel.barLabel">
        {{ channel.barLabel || 'graph.bar.table.bar-label.no-label' | translate }}
        <div class="select-button" (click)="openBarLabelSelector()" *ngIf="!channel.barLabel">
            {{ 'graph.bar.table.bar-label.add-label' | translate }}
        </div>
        <div class="select-button" (click)="openBarLabelSelector()" *ngIf="channel.barLabel">
            {{ 'graph.bar.table.bar-label.change-label' | translate }}
        </div>
    </div>
    <div class="col-options column" #iconButton>
        <app-more-options-dropdown
            [isOpen]="optionsVisible"
            (toggle)="openOptions()"
            [options]="moreOptions"
            (optionSelected)="onMoreOptionSelected($event)">
        </app-more-options-dropdown>
    </div>
</div>

<ng-template #channelRow let-channel="channel" let-selector="selector">
    <div class="channel-row" *ngIf="channel">
        <div>{{ channel.fcuData.fcuChannelId }}</div>
        <div class="channel-name">{{ channel.opsData.name }}</div>
        <div class="select-button" (click)="openChannelSelector()">
            {{ 'graph.bar.table.channel.button.change' | translate }}
        </div>
    </div>
</ng-template>